export async function fetchLatest({ baseUrl, tenantId, env, tourId, etag, token, previewToken, }) {
    const qp = new URLSearchParams({ tenant: tenantId, env });
    if (previewToken)
        qp.set('previewToken', previewToken);
    const url = `${baseUrl.replace(/\/$/, '')}/api/tours/v1/${encodeURIComponent(tourId)}?${qp.toString()}`;
    const res = await fetch(url, {
        method: 'GET',
        headers: {
            ...(etag && !previewToken ? { 'If-None-Match': etag } : {}),
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        },
        credentials: 'include',
    });
    if (res.status === 304) {
        const newTag = res.headers.get('ETag') ?? etag ?? '';
        return { status: 304, etag: newTag };
    }
    if (!res.ok)
        throw new Error(`fetchLatest failed: ${res.status}`);
    const et = res.headers.get('ETag') ?? '';
    const body = await res.json();
    const tour = (body?.data ?? body); // controller returns {ok, etag, data}
    return { status: 200, etag: et || body?.etag || '', tour };
}
//# sourceMappingURL=client.js.map